import { Skeleton } from "@mui/material";
import { PageBreadcrumb } from "src/components/PageBreadcrumb";
import { PageHeader } from "src/components/PageHeader/PageHeader";

export const ChangeManagementPlansSkeleton = () => (
  <div
    className="flex flex-col"
    aria-label="Loading change management runs"
    aria-busy="true"
  >
    <PageHeader
      pageTitleComponent={
        <PageBreadcrumb items={[{ label: "Change management" }]} />
      }
      rightButtons={<Skeleton variant="rounded" width={90} height={30} />}
      rightPanelToggleRequiresDevice={false}
    />
    <div className="flex flex-col gap-6 p-4" aria-hidden="true">
      <div className="flex flex-col gap-2">
        <Skeleton width={220} height={34} />
        <Skeleton width="55%" />
      </div>
      <div className="rounded border border-solid border-black/[.12] bg-white">
        {Array.from({ length: 5 }, (_, row) => (
          <div
            key={row}
            className="flex min-h-[52px] items-center gap-4 border-0 border-b border-solid border-black/[.12] px-4 last:border-b-0"
          >
            <Skeleton className="grow" />
            <Skeleton width={90} />
            <Skeleton width={90} />
            <Skeleton width={70} />
          </div>
        ))}
      </div>
    </div>
  </div>
);
